import {useState} from "react";
import useToggle from "../shared/functions/useToggle";
import NewCategory from "../components/categories/fragments/NewCategory";

export default function useCategoryModal() {
    const [selected, setSelected] = useState(null);
    const {open, handleOpen, handleClose} = useToggle();

    const handleOpenWith = (category) => {
        setSelected(category);
        handleOpen();
    }

    const CategoryModal = () =>
        (
            <NewCategory
                open={open}
                selected={selected}
                onClose={handleClose}
            />
        )

    return {handleOpen, handleOpenWith, CategoryModal}
}